localizeOptions